import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import React from "react";
import { CPagesPath } from "shared/models/const/pages-path";
import { Avatar, Box } from "@mui/material";
import { styled } from "@mui/material/styles";

const CollectionLogoContent = styled(Box)({
  position: "relative",
  width: "150px",
  alignSelf: "flex-start",
});

const ContentLogo = styled(Box)({
  position: "absolute",
  padding: "1rem",
  top: "-38px",
  left: "-5px",
  width: "100%",
  height: "100px",
  background: "var(--color-brand-blue-collection-main)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "0 0 20px 20px",
});

const LogoImage = styled(Image)({
  cursor: "pointer",
});

const Logo = React.forwardRef(function FLogo(props: any, ref: React.Ref<any>) {
  const location = useRouter();
  return (
    <Box>
      {location.pathname.includes(CPagesPath.es.collection) ? (
        <CollectionLogo ref={ref} />
      ) : (
        <RemaxRdLogo ref={ref} />
      )}
    </Box>
  );
});

export default Logo;

const CollectionLogo = React.forwardRef(function FCollection(
  props: any,
  ref: React.Ref<any>
) {
  return (
    <CollectionLogoContent ref={ref}>
      <ContentLogo>
        <Link href={CPagesPath.es.collection} className="logo" passHref>
          <Avatar
            src="/images/v2/logos/collection-02.png"
            alt="Logo Re/max"
            sx={{
              width: 120,
              height: "auto",
              objectFit: "cover",
            }}
            variant="square"
          />
        </Link>
      </ContentLogo>
    </CollectionLogoContent>
  );
});

const RemaxRdLogo = React.forwardRef(function FRemax(
  props: any,
  ref: React.Ref<any>
) {
  return (
    <Link href="/" className="logo__link" ref={ref} passHref>
      <a>
        <Avatar
          src="/images/v2/logos/8.png"
          alt="Logo Re/max"
          sx={{
            width: 200,
            height: "auto",
            objectFit: "contain",
          }}
          variant="square"
        />
      </a>
    </Link>
  );
});
